module.exports = __webpack_public_path__ + "img/dna_campeao.e1aa8a42.png";